export default function getFormattedToISO(dateString) {
  // convert MM-DD-YYYY to YYYY-MM-DD
  let split = dateString.split('-');
  split = split.map((e) => (e.length === 1 ? `0${e}` : e));
  return `${split[2]}-${split[0]}-${split[1]}`;
}
